/* eslint-disable */

var icon = require('vue-svgicon')
icon.register({
  'checkmark_circled': {
    width: 28.001,
    height: 28,
    viewBox: '0 0 28.001 28',
    data: `<path pid="0" fill-rule="evenodd" _fill="#58B69E" d="M11.682 18.64c-.09-.12-.15-.22-.22-.29l-3.23-3.46c-.3-.33-.66-.39-.92-.15-.26.23-.25.59.04.9 1.27 1.36 2.54 2.72 3.82 4.08.38.39.69.38 1.06-.01l8.32-8.89c.37-.41.43-.74.16-.99-.28-.28-.61-.21-1 .2l-7.78 8.31c-.08.08-.14.16-.25.3zm-10.54-4.67c.1-7.19 5.76-12.77 12.82-12.8 7.06-.03 12.88 5.57 12.88 12.84 0 7.33-5.95 12.88-12.93 12.83-6.881-.05-12.71-5.54-12.77-12.87zM14.011 0C6.021.05-.109 6.52.001 14.2c.12 7.8 6.47 13.85 14.08 13.8 7.78-.05 13.96-6.36 13.92-14.03C27.961 6.1 21.631.03 14.011 0z"/>`
  }
})
